var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.59692H7C4.23858 2.59692 2 4.8355 2 7.59692V17.5969C2 20.3583 4.23858 22.5969 7 22.5969H17C19.7614 22.5969 22 20.3583 22 17.5969V7.59692C22 4.8355 19.7614 2.59692 17 2.59692Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 11.967C16.1231 12.7992 15.981 13.6492 15.5935 14.396C15.206 15.1428 14.5929 15.7484 13.8413 16.1267C13.0898 16.5049 12.2382 16.6366 11.4075 16.5029C10.5768 16.3692 9.80947 15.9771 9.21455 15.3821C8.61962 14.7872 8.22744 14.0199 8.09377 13.1892C7.96011 12.3585 8.09177 11.5069 8.47003 10.7554C8.84829 10.0038 9.45389 9.39072 10.2007 9.00322C10.9475 8.61572 11.7975 8.47357 12.6297 8.59698C13.4786 8.72287 14.2646 9.11844 14.8714 9.72529C15.4782 10.3321 15.8738 11.1181 15.9997 11.967Z",
    fill: "#007F9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.09692H17.51",
    stroke: "#097AD4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2f9455e2ac1607b9d0a6af6378997d6f.svg";
export { ForwardRef as ReactComponent };